import { Checkbox, CheckboxProps } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Controller, useFormContext } from 'react-hook-form';

type FormCheckboxProps = CheckboxProps & {
  name: string;
  children: React.ReactNode;
};

export const FormCheckbox = ({ name, children, ...props }: FormCheckboxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => {
        const handleOnChange = (e: CheckboxChangeEvent) => {
          onChange(e.target.checked);
        };
        return (
          <Checkbox checked={value} onChange={handleOnChange} {...props}>
            {children}{' '}
          </Checkbox>
        );
      }}
    />
  );
};
